export default "__VITE_ASSET__79d64223__"